export function sortAlphabetically(array, fieldName) {
	if (!array) {
		return;
	}

	if (!fieldName) {
		throw new Error('sortAlphabetically(): fieldName is not provided');
	}

	return array.sort((a, b) => a[fieldName].localeCompare(b[fieldName]));
}
